/* eslint-disable no-unused-vars */
/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

import axios from 'axios';
import moment from 'moment';
import { faGlasses } from '@fortawesome/free-solid-svg-icons';
import * as actionTypes from './actionTypes';
import * as serviceEndPoint from '../../../../SharedModules/services/service';
import { NO_DATA } from '../../../../SharedModules/Errors/constantMessageData';
// dispatch function for tab data for request current Dispute Display screen
export const dispatchPerformDisputeResolutionObj = (data) => ({
  type: actionTypes.GET_CURRENT_DISPUTE_DISPLAY_OBJ_RECAP,
  screenData: data,
});
// plan Type dispatch
export const dispatchPlanType = (data) => ({
  type: actionTypes.GET_PLAN_TYPE_DATA_RECAP,
  payload: data,
});
// recap Grid
export const dispatchRecapGrid = (data) => ({
  type: actionTypes.GET_DISPLAY_RECAP_GRID,
  payload: data,
});
//  error msg dispatch function
export const dispatchErrorMsgDisputeRecap = (data) => ({
  type: actionTypes.GET_ERROR_MSG_DISPUTE_RECAP,
  payload: data,
});
// error message for 5 sec for no data exists
export const showNoDataMessage = () => (dispatch) => {
  // setTimeout(() => {
    dispatch(dispatchErrorMsgDisputeRecap([]));
  // }, 5000);
  dispatch(
    dispatchErrorMsgDisputeRecap([
      {
        field: 'noData',
        message: NO_DATA,
      },
    ])
  );
};
// Manufactuerer Name Display
export const getManufactureName = (value) => ({
  type: actionTypes.GET_MANUFACTURER_NAME_RECAP,
  allManufacturer: value,
});
// Manufacturer ID display
export const getManufactureID = (value) => ({
  type: actionTypes.GET_MANUFACTURER_ID_RECAP,
  manufactureWithIds: value,
});
// dispatch quarter from
export const dispatchFrom = (data) => ({
  type: actionTypes.GET_FROM_RECAP,
  payload: data,
});
// dispatch quarter to
export const dispatchTo = (data) => ({
  type: actionTypes.GET_TO_RECAP,
  payload: data,
});
// dispatch DRAMS
export const dispatchDRAMS = (data) => ({
  type: actionTypes.GET_DRAMS_INVOICE_START_QUARTER_VALUE_RECAP,
  payload: data,
});
// drug selected
export const dispatchDrugSelected = (data) => ({
  type: actionTypes.GET_DRUG_RECAP,
  payload: data,
});
// quarter selected
export const dispatchQuarterSelected = (data) => ({
  type: actionTypes.GET_QUARTER_RECAP,
  payload: data,
});
// recently closed
export const dispatchRecentlyClosed = (data) => ({
  type: actionTypes.GET_RECENTLY_CLOSED,
  payload: data,
});
// include activity
export const dispatchIncludeActivity = (data) => ({
  type: actionTypes.GET_INCLUDE_ACTIVITY,
  payload: data,
});
// To dispatch plantype data
export const getPlanTypeValues = () => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_COMMON_MANUFACUTRE_DROPDOWNS, {
      codeDomainList: ['PLAN_TYPE_CD'],
    })
    .then((response) => {
      return dispatch(dispatchPlanType(response.data));
    })
    .catch((response) => {
      dispatch(dispatchPlanType([]));
    });
};
// rebate programe dispatch function
export const dispatchRebateProgramName = (data) => ({
  type: actionTypes.GET_REBATE_PROGRAM_NAME_RECAP,
  payload: data,
});
// rebate programe dispatch function
export const dispatchRebatePrograme = (data) => ({
  type: actionTypes.GET_REBATE_PROGRAM_RECAP,
  payload: data,
});
//  get rebate programe function
export const getRebateProgrameList = (value) => (dispatch) => {
  return axios
    .post(`${serviceEndPoint.SYSTEM_LIST_ALL_DROPDOWN}`, { planType: value })
    .then((response) => {
      return response.data;
    })
    .catch((response) => {});
};
// Manufacturer Grid
export const getManufacturerList = (values) => (dispatch) => {
  return axios
    .post(
      `${serviceEndPoint.REBATE_PERCENT_OF_SPEND_MANUFACTURER_GRID}`,
      values
    )
    .then((response) => {
      return dispatch({
        type: actionTypes.GET_MANUFACTURERS_LIST_RECAP,
        manufacturerList: response.data,
      });
    })
    .catch((response) => {
      dispatch([]);
      return response;
    });
};

export const updateRecapMailoutDate = (value) => (dispatch) => {
  axios
    .post(serviceEndPoint.UPDATE_RECAP_MAIL_OUT, value)
    .then((response) => {
      dispatch(setLoading(false));
      // dispatch({
      //   type: actionTypes.UPDATE_RECAP_MAILOUT_DT,
      //   payload: response.data,
      // });
      return response.data;
    })
    .catch((response) => response);
};

export const dispatchMailOut = (val) => ({
  type: actionTypes.UPDATE_RECAP_MAILOUT_DT,
  payload: val,
});

export const getRecapMailoutDate = (value) => (dispatch) => {
  axios
    .post(serviceEndPoint.GET_RECAP_MAIL_OUT, value)
    .then((response) => {
      dispatch(setLoading(false));
      let value = null;
      if (response.data?.rebateRecapMailOutDTVO?.length) value = true;
      else if (response.data?.rebateRecapMailOutDTVO?.length === 0)
        value = false;
      dispatch(dispatchMailOut(value));
    })
    .catch((response) => dispatch(dispatchMailOut(null)));
};

export const setLoading = (value) => ({
  type: actionTypes.SET_LOADING_DISPUTE_RECAP,
  payload: value,
});
export const getDisputeCodeRes = (value) => (dispatch) => {
  axios
    .post(serviceEndPoint.GET_DISPUTE_CODE_RECAP, value)
    .then((response) => {
      dispatch({
        type: actionTypes.GET_CODE_DATA,
        payload: response.data,
      });
    })
    .catch((response) => response);
};
// display Reacp Grid
export const getDisplayRecapGrid = (value) => (dispatch) => {
  dispatch(setLoading(true));
  return axios
    .post(serviceEndPoint.DISPLAY_RECAP_GRID, value)
    .then((response) => {
      if (response.data.rebateRecapGridVO.length == 0) {
        dispatch(showNoDataMessage());
        dispatch(setLoading(false));
      } else {
        dispatch(dispatchRecapGrid(response.data));
        dispatch(getDisputeCodeRes(value));
      }
    })
    .catch((response) => {
      dispatch(setLoading(faGlasses));

      dispatch(dispatchRecapGrid([]));
    });
};
// get DRAMS
export const getDramsInvStartQtr = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_DRAMS_INVOICE_START_QUARTER, value)
    .then((response) => {
      return dispatch(dispatchDRAMS(response.data));
    })
    .catch((response) => {
      dispatch(dispatchDRAMS([]));
    });
};
// refresh dispute recap
export const refreshDisputeRecap = () => ({
  type: actionTypes.SET_REFRESH_DATA_RECAP,
  payload: {},
});
export const refreshDisputeRecapDisplay = () => ({
  type: actionTypes.REFRESH_DATA_RECAP_DISPLAY,
  payload: {},
});
// dispatch Display screen Object
export const dispatchDisplayObjRecap = (data) => ({
  type: actionTypes.SET_DISPLAY_OBJ_RECAP,
  payload: data,
});
// include activity
export const dispatchIncludeActivityDropDown = (data) => ({
  type: actionTypes.GET_INCLUDE_ACTIVITY_DROPDOWN,
  payload: data,
});
export const activityTableData = (data) => ({
  type: actionTypes.ACTIVITY_TABLE_DATA,
  payload: data,
});
// get include activity
export const getIncludeActivityDetailsChecked = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_INCLUDE_ACTIVITY_DETAIL, value)
    .then((response) => {
      dispatch(setLoading(false));
      return dispatch(
        activityTableData(response?.data?.rebateRecapActivityDetailsCheckedVO)
      );
    })
    .catch((response) => {
      dispatch(setLoading(false));
      dispatch(activityTableData([]));
    });
};
// get include activity all
export const getIncludeActivity = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.DISPUTE_RECAPITULATION_INCLUDE_ACTIVITY, value)
    .then((response) => {
      return dispatch(dispatchIncludeActivityDropDown(response.data));
    })
    .catch((response) => {
      dispatch(dispatchIncludeActivityDropDown([]));
    });
};
